<template>
  <div class="app-wrapper">
    <sidebar></sidebar>
    <div v-if="auth.loading">
      Loading...
    </div>
    <div class="main_content">
      <Header></Header>
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import ChatSupport from './components/CRM/ChatSupport.vue'
import Header from '@/components/Header.vue';
import Footer from './components/Footer.vue'
import sidebar from './components/SideBar.vue'
import { useAuthStore } from './stores/authStore'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'App',
  components: {
    ChatSupport,
    FontAwesomeIcon,
    Header,
    Sidebar: sidebar,
    Footer,
  },
  data() {
    return {
      auth: useAuthStore()
    };
  },
  mounted() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').then((reg) => {
        console.log('Service worker registrado:', reg);
      });

      // Recibir mensajes desde el service worker
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data.type === 'UPDATE_BADGE') {
          this.updateFaviconBadge(event.data.badgeCount);
          this.updateTitle(event.data.badgeCount);
        }
      });
    }
  },
  methods: {
    updateFaviconBadge(count) {
      const favicon = document.querySelector("link[rel='icon']");
      if (!favicon) return;

      const canvas = document.createElement('canvas');
      canvas.width = 64;
      canvas.height = 64;

      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.src = favicon.href;
      img.onload = () => {
        ctx.drawImage(img, 0, 0, 64, 64);

        // Dibuja el círculo del contador
        if (count > 0) {
          ctx.beginPath();
          ctx.arc(40, 24, 24, 0, 2 * Math.PI);
          ctx.fillStyle = 'red';
          ctx.fill();

          // Dibuja el número
          ctx.fillStyle = 'white';
          ctx.font = 'bold 42px sans-serif';
          ctx.textAlign = 'center';
          ctx.fillText(String(count), 40, 40);
        }

        favicon.href = canvas.toDataURL('image/png');
      };
    },
    updateTitle(count) {
      const titleEl = document.querySelector("title");
      if (!titleEl) return;

      titleEl.text = count + ' | Sub Slot';
    }
  },
}
</script>
